import { cx } from "@/utils";
import Typography from "@components/Typography";
import * as Dialog from "@radix-ui/react-dialog";

import styles from "../Modal.module.css";

type ModalTitleProps = {
  children: React.ReactNode;
  className?: string;
};

const ModalTitle: React.FunctionComponent<ModalTitleProps> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <Dialog.Title asChild>
      <Typography
        className={cx(styles.title, className)}
        {...rest}
        variant="h3"
      >
        {children}
      </Typography>
    </Dialog.Title>
  );
};

export default ModalTitle;
